import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RessData } from "../types/ress";

type IncomingRessTraceData = {
  carColour: string | null;
  ressTCellMax: number[] | null;
  ressPBMSkW: number[] | null;
};

const initialState: RessData = {};

export const ressSlice = createSlice({
  name: "ress",
  initialState,
  reducers: {
    setRessTraces: (state, action: PayloadAction<IncomingRessTraceData[]>) => {
      for (const { carColour, ressTCellMax, ressPBMSkW } of action.payload) {
        if (!carColour) continue;
        state[carColour] = {
          ressTCellMax: ressTCellMax ?? [],
          ressPBMSkW: ressPBMSkW ?? [],
        };
      }
    },
    updateRessTraces: (state, action: PayloadAction<IncomingRessTraceData>) => {
      const { carColour, ressTCellMax, ressPBMSkW } = action.payload;
      if (!carColour) return;
      state[carColour] = {
        ressTCellMax: ressTCellMax ?? [],
        ressPBMSkW: ressPBMSkW ?? [],
      };
    },
  },
});

export const { setRessTraces, updateRessTraces } = ressSlice.actions;
export default ressSlice.reducer;
